import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";
import CustomerNav from "./components/CustomerNav";
import Footer from "./components/Footer";
import AdminLayout from "./components/AdminLayout";
import { ProtectedRoute, AdminRoute } from "./components/ProtectedRoute";
import AuthPage from "./pages/AuthPage";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import ProductListingPage from "./pages/ProductListingPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import FarmerProfilePage from "./pages/FarmerProfilePage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrdersPage from "./pages/OrdersPage";
import ProfilePage from "./pages/ProfilePage";
import ContactPage from "./pages/ContactPage";
import OurStoryPage from "./pages/OurStoryPage";
import MissionPage from "./pages/MissionPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminFarmers from "./pages/admin/AdminFarmers";
import AdminAddFarmer from "./pages/admin/AdminAddFarmer";
import AdminFarmerDetail from "./pages/admin/AdminFarmerDetail";
import AdminEditFarmer from "./pages/admin/AdminEditFarmer";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminInventory from "./pages/admin/AdminInventory";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminContent from "./pages/admin/AdminContent";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminDelivery from "./pages/admin/AdminDelivery";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminProductEdit from "./pages/admin/AdminProductEdit";
import AdminOrderDistribution from "./pages/admin/AdminOrderDistribution";

function CustomerLayout() {
  return (
    <>
      <CustomerNav />
      <main className="min-h-screen"><Outlet /></main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            <Route element={<CustomerLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/products" element={<ProductListingPage />} />
              <Route path="/product/:productId" element={<ProductDetailPage />} />
              <Route path="/farmer/:farmerId" element={<FarmerProfilePage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
              <Route path="/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/our-story" element={<OurStoryPage />} />
              <Route path="/mission" element={<MissionPage />} />
            </Route>
            <Route path="/admin/login" element={<AuthPage isAdmin />} />
            <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="farmers" element={<AdminFarmers />} />
              <Route path="farmers/add" element={<AdminAddFarmer />} />
              <Route path="farmers/:id" element={<AdminFarmerDetail />} />
              <Route path="farmers/:id/edit" element={<AdminEditFarmer />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="distribution" element={<AdminOrderDistribution />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="products/new" element={<AdminProductEdit />} />
              <Route path="products/:id/edit" element={<AdminProductEdit />} />
              <Route path="inventory" element={<AdminInventory />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="delivery" element={<AdminDelivery />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
